var _rect, _path, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUpGrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37.001px",
    height: "45px",
    viewBox: "0 0 37.001 45",
    enableBackground: "new 0 0 37.001 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    y: 0.174,
    fill: "none",
    width: 37,
    height: 44.826
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M35.912,0.186l-21.706,2.75c-0.252,0.027-0.449,0.23-0.487,0.495c-0.037,0.26,0.093,0.513,0.323,0.615 c1.382,0.642,2.52,1.545,3.521,2.564C4.604,14.567-2.205,29.855,0.641,45l5.844-1.211C4.132,31.283,9.791,18.625,20.547,12.011 c0.297,1.319,0.411,2.681,0.207,4.079c-0.037,0.253,0.09,0.498,0.3,0.614c0.081,0.039,0.163,0.063,0.253,0.063 c0.144,0,0.285-0.063,0.396-0.179L36.375,1.182c0.17-0.176,0.209-0.449,0.111-0.67C36.375,0.286,36.167,0.127,35.912,0.186"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    fill: "none",
    width: 37,
    height: 45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.001,
    width: 37,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#C6C6C6",
    points: "36.221,28.773 31.682,24.238 26.471,29.449 21.259,24.238  16.72,28.773 21.932,33.988 16.72,39.199 21.259,43.738 26.471,38.527 31.682,43.738 36.221,39.199 31.009,33.988  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpGrau);
export default __webpack_public_path__ + "static/media/noUp_Grau.94441964b656423c9dbfa55a4f02758f.svg";
export { ForwardRef as ReactComponent };